import React from 'react';
import { Paper, Title, Text, Stack } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';

/**
 * OsmImportHistory Component
 *
 * Placeholder component for displaying recent OSM import history.
 * Full implementation planned for future sprint when import logging is added.
 *
 * @example
 * <OsmImportHistory />
 */
export const OsmImportHistory: React.FC = (): React.ReactElement => {
  return (
    <Paper p="md" withBorder>
      <Stack gap="xs" align="center">
        <IconHistory size={32} stroke={1.5} color="var(--mantine-color-gray-5)" />
        <Title order={4}>Import History</Title>
        <Text size="sm" c="dimmed" ta="center">
          Import history tracking will be implemented in a future sprint.
          <br />
          Check the backend logs for import details.
        </Text>
      </Stack>
    </Paper>
  );
};
